<template>
  <div class="page-intro">
    <div class="banner"></div>
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`/feature-gslc/achievement/show`">成果转化</el-breadcrumb-item>
        <el-breadcrumb-item :to="`/feature-gslc/achievement/show/research/list`">科研单位</el-breadcrumb-item>
        <el-breadcrumb-item>{{ model.Name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content">
        <div class="head">
          <h3 class="title">{{ model.Name }}</h3>
          <div class="attrs">
            <div>
              <!-- <span class="time">提问人：{{ model.RaiseByName }}</span> -->
            </div>
          </div>
        </div>
        <div class="content" v-html="model.Contents"></div>
        <!-- <div>
          <div class="answer_box" v-for="item in model.AnswerList" :key="item.Id">
            <div class="answer" v-html="item.Answer"></div>
            <div class="answer_item">
              <span class="name">{{ item.AnswerUserName }}</span>
              <span class="time">回答时间：{{ formartDate(item.AnswerTime, "minute") }}</span>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getDetail } from "@/api/app";
export default {
  data() {
    return {
      model: {}
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      getDetail({ name: "Scientific", id: this.$route.params.id })
        .then(res => {
          this.model = res;
          console.log(res);
        })
        .catch(err => console.log(err));
    }
  }
};
</script>

<style lang="scss" scoped>
.page-intro {
  background-color: #f6f6f9;
  padding-bottom: 40px;
  .banner {
    background: url(~assets/img/feature/socialServices/banner.png) no-repeat
      center top;
    background-size: 100% 100%;
    height: 160px;
  }
  .title {
    font-size: 32px;
    color: #333333;
    font-weight: 500;
    padding: 8px 0 15px 0;
    line-height: 1.4em;
  }
  .head {
    margin: 0 0 32px 0;
    border-bottom: 1px solid #eee;
  }
  .attrs {
    font-size: 16px;
    color: #999999;
    line-height: 18px;
    padding-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .info {
      .time {
        padding-right: 30px;
      }
    }
  }
  .content {
    font-size: 18px;
    color: rgba(51, 51, 51, 1);
    line-height: 1.8em;
    ::v-deep p {
      text-indent: 2em;
      padding-bottom: 1em;
    }
  }
  .answer_box {
    margin: 16px 0;
    .answer {
      font-size: 18px;
      color: #333333;
    }
    .answer_item {
      margin-top: 4px;
      font-size: 14px;
      color: #999;
      .name {
        color: $primary-color;
      }
      .time {
        margin-left: 8px;
      }
    }
  }
}
</style>
